// The job_details.status enum, ordered by the phases a job moves through, and
// coloured on the same scheme as the project statuses: offer (purple/teal/rose),
// work (gray/blue/orange), delivery (indigo/green/red), and cancelled (gray).
export const JOB_STATUSES = [
  "Draft",
  "Offered to Vendor",
  "Offer Accepted",
  "Offer Rejected",
  "Started",
  "Hold",
  "Completed",
  "Completion Accepted",
  "Completion Rejected",
  "Cancelled",
];

const STYLES = {
  Draft:                 { badge: "bg-gray-100 text-gray-600",     dot: "bg-gray-400" },
  "Offered to Vendor":   { badge: "bg-purple-100 text-purple-700", dot: "bg-purple-500" },
  "Offer Accepted":      { badge: "bg-teal-100 text-teal-700",     dot: "bg-teal-500" },
  "Offer Rejected":      { badge: "bg-rose-100 text-rose-700",     dot: "bg-rose-500" },
  Started:               { badge: "bg-brand-100 text-brand-700",     dot: "bg-brand-500" },
  Hold:                  { badge: "bg-orange-100 text-orange-700", dot: "bg-orange-500" },
  Completed:             { badge: "bg-indigo-100 text-indigo-700", dot: "bg-indigo-500" },
  "Completion Accepted": { badge: "bg-green-100 text-green-700",   dot: "bg-green-500" },
  "Completion Rejected": { badge: "bg-danger-100 text-danger-700",       dot: "bg-danger-500" },
  Cancelled:             { badge: "bg-gray-200 text-gray-500",     dot: "bg-gray-300" },
};

const FALLBACK = { badge: "bg-gray-100 text-gray-600", dot: "bg-gray-400" };

export const jobStatusStyle = (status) => STYLES[status] || FALLBACK;
